import { render, staticRenderFns } from "./MathPractice.vue?vue&type=template&id=3f3e8e46&scoped=true&"
import script from "./MathPractice.vue?vue&type=script&lang=js&"
export * from "./MathPractice.vue?vue&type=script&lang=js&"
import style0 from "./MathPractice.vue?vue&type=style&index=0&id=3f3e8e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e8e46",
  null
  
)

export default component.exports